import apiClient from '../config/api';
import { getUserId, getWorkshopId } from '../config/constants';


/**
 * Servicio para todas las operaciones relacionadas con clientes
 */
export const clientService = {
    /**
     * Obtener todos los clientes del taller actual
     * GET /{workshop_id}/customers
     */
    getClients: async () => {
        const workshopId = getWorkshopId();
        if (!workshopId) {
            throw new Error('Taller no seleccionado');
        }

        const response = await apiClient.get(`/${workshopId}/customers`);
        return response.data;
    },

    /**
     * Obtener un cliente por ID
     * GET /customer/{id}
     */
    getClientById: async (clientId) => {
        const workshopId = getWorkshopId();
        const response = await apiClient.get(`${workshopId}/customer/${clientId}`);
        return response.data;
    },

    /**
     * Crear un nuevo cliente
     * POST /{workshop_id}/customer
     *  @param {Objet} clientData - Datos del cliente
     *  @param {String} clientData.name - Nombre(s) del cliente
     *  @param {String} clientData.first_lastname - Primer apellido
     *  @param {String} clientData.second_lastname - Segundo apellido (opcional)
     *  @param {String} clientData.email - Correo electrónico
     *  @param {String} clientData.phone - Teléfono principal
     *  @param {String} clientData.second_phone - Teléfono secundario (opcional)
     *  @param {String} clientData.address - Dirección
     *  @param {String} clientData.RFC - RFC (opcional)
     *  @param {String} clientData.company_name - Nombre de empresa (opcional)
     */
    createClient: async (clientData) => {
        const userId = getUserId();
        const workshopId = getWorkshopId();

        if (!userId) {
            throw new Error('Usuario no seleccionado');
        }

        if (!workshopId) {
            throw new Error('Taller no seleccionado');
        }

        const payload = {
            data: clientData
        };

        const response = await apiClient.post(`/${workshopId}/customer`, payload);
        return response.data;
    },

    /**
     * Actualizar un cliente existente
     * PUT /{workshop_id}/customer/{client_id}
     */
    updateClient: async (clientId, clientData) => {
        const userId = getUserId();
        const workshopId = getWorkshopId();

        if (!userId) {
            throw new Error('Usuario no seleccionado');
        }

        if (!workshopId) {
            throw new Error('Taller no seleccionado');
        }

        const response = await apiClient.put(
            `/${workshopId}/customer/${clientId}`,
            { data: clientData }
        );
        return response.data;
    },

    /**
     * Eliminar un cliente
     * DELETE /{workshop_id}/customer/{client_id}
     */
    deleteClient: async (clientId, isDeleted) => {
        const userId = getUserId();
        const workshopId = getWorkshopId();

        if (!userId) {
            throw new Error('Usuario no seleccionado');
        }

        if (!workshopId) {
            throw new Error('Taller no seleccionado');
        }

        const response = await apiClient.put(
            `/${workshopId}/customer/${clientId}`,
            { data: isDeleted }
        );
        return response.data;
    },

    /**
     * Obtener todos los vehículos de un cliente
     * GET /{workshop_id}/cars/{client_id}
     */
    getClientVehicles: async (clientId) => {
        const userId = getUserId();
        const workshopId = getWorkshopId();

        if (!userId) {
            throw new Error('Usuario no seleccionado');
        }

        if (!workshopId) {
            throw new Error('Taller no seleccionado');
        }

        const response = await apiClient.get(
            `/${workshopId}/cars/${clientId}`
        );
        return response.data;
    }
};